import { Empty, message, Spin } from "antd";
import React, { useEffect, useState } from "react";

import { apiCall } from "../../utils/Api";
import ItemLayouts from "../ItemLayouts";
import Conditions from "../Conditions";
import TitleExtras from "./TitleExtras";

export default function PreviousRender(props) {
    const { isbn } = props;
    const [loading, setLoading] = useState(true);
    const [previous, setPrevious] = useState("")
    const [data, setData] = useState(false);
    const getPreviousEdition = () => {
        apiCall("title/getRelatedEditions", { isbn: isbn }, (_status, _result) => {
            if (_result.previous_edition.isbns.length > 0) {
                setPrevious(_result.previous_edition.isbns[0]);
                getItem(_result.previous_edition.isbns[0])
            } else {

            }
            setLoading(false)
        })
    }

    const getItem = (_isbn) => {

        apiCall("title/getItem", { isbn: _isbn }, (_status, _result) => {
            if (_status) {
                setData(_result);
            }
            setLoading(false);
        })

    }

    useEffect(getPreviousEdition, []);

    return (<>
        <Spin spinning={loading} >
            {(previous && data && <div><ItemLayouts isbn={previous} display="single" />
                <>
                    <TitleExtras
                        calendar={true}
                        small={true}
                        hideTabs={["store_data", "peer_data", "lifetime_sales", "all"]}
                        peerDataOpen={false}
                        can_see_sales={data.can_see_sales}
                        setPeerDataOpen={() => { }}
                        data={data}
                        isbn={(data) ? data.isbn : isbn}
                        conditions={data.sales ? data.sales : data.conditions}
                        dataSet={data}

                    />

                    <Conditions
                        small={true}
                        peerDataOpen={false}
                        setPeerDataOpen={() => {}}
                        sideColumn={true}
                        conditions={data.sales ? data.sales : data.conditions}
                        data={data}
                        isbn={(data) ? data.isbn : isbn}
                    />
                </>

            </div>)}
            {(!previous && <div style={{ "height": "200px", "display": "flex", "flexDirection": "column-reverse" }}><Empty description="No previous edition found." image={Empty.PRESENTED_IMAGE_SIMPLE} /></div>)}
        </Spin>
    </>)
}